import MyRewards from '../../../components/screens/shop/my-rewards/MyRewards';

const MyRewardsContainer = () => {
  return <MyRewards />;
};

export default MyRewardsContainer;
